import {ActionType} from '../../../types';

/**
 *
 * @param isRtlConfig
 * @param actionName
 */
export const resolveTrackingActionName = (
    isRtlConfig: boolean,
    actionName: ActionType
): ActionType => {
    if (!isRtlConfig) return actionName;

    return actionName.replace(/left|right/, match =>
        match === 'left' ? 'right' : 'left'
    ) as ActionType;
};
